import { BaseHttpClient } from '@/modules/common/services/http/__deprecated__/base-http-client';
import {
  IBankSlipReceipt,
  IBarCodeResponse,
  IGetBarCodeData,
  IPaymentBarCodeData,
  IPaymentHeaders,
  IPaymentScheduleResponse
} from './banking-types';

export class BankingAPI extends BaseHttpClient {
  constructor(headers?: IPaymentHeaders) {
    super();
    this.optionalHeaders = headers;
  }

  public getBankSlipReceipt(id: string) {
    return id
      ? this.get<IBankSlipReceipt>(`/api/v1/banking/bank-slip-receipt/${id}`)
      : undefined;
  }

  public cancelPaymentScheduled(id: string) {
    return this.post<IPaymentScheduleResponse>(
      `/api/v1/banking/payment/${id}/cancel`
    );
  }

  public getBarCode(data: IGetBarCodeData) {
    return this.post<IBarCodeResponse>(
      `/api/v1/banking/validate-bar-code`,
      data
    );
  }

  public payBarCode(data: IPaymentBarCodeData) {
    return this.post<IPaymentScheduleResponse>(
      `api/v1/banking/pay-bank-slip`,
      data
    );
  }

  public getBankSlipReceiptPdf(id: string, type: string) {
    return id
      ? this.get<any>(
          `api/v1/banking/bank-slip-receipt/${id}/download?type=${type}`,
          {
            responseType: 'blob'
          }
        )
      : undefined;
  }
}
